import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { DocumentsStore } from "@/Documents/Stores/DocumentsStore";

class DocumentTableDisplaySettingsHandler extends BaseOperationHandler {
    constructor() {
        super();
        this.RegisterOperation(LocalOperations.Documents.DisplaySettings_CloseColumOrderPopupClick, this.HideColumnOrderingPopup);
        this.RegisterOperation(LocalOperations.Documents.DisplaySettings_ShowColumOrderPopupClick, this.ShowColumnOrderingPopup);
    }

    private HideColumnOrderingPopup(request: LocalEvent, store: DocumentsStore): void {
        store.DocumentsModel = store.DocumentsModel.set("ColumnOrderingPopupOpen", false);
    }

    private ShowColumnOrderingPopup(request: LocalEvent, store: DocumentsStore): void {
        store.DocumentsModel = store.DocumentsModel.set("SearchOptionsOpen", false);
        store.DocumentsModel = store.DocumentsModel.set("ColumnOrderingPopupOpen", true);
    }
}

export { DocumentTableDisplaySettingsHandler };
